














































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import registrations from "@/getinfo-api/courseRegistrations";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import {
  Course as ICourse,
  Registration as IRegistration
} from "@/api-v2/course/models";
import CourseRegistrationsTableItem from "@/components/courses/CourseRegistrationsTableItem.vue";
import { RegistrationSort, SortFields } from "@/plugins/sort-fields";
import { learningGroupsApi } from "@/getinfo-api";
import LearningGroupStudentTableItem from "@/components/learning-group/LearningGroupStudentTableItem.vue";
import LearningGroupAddStudentsTableItem from "@/components/learning-group/LearningGroupAddStudentsTableItem.vue";

@Component({
  components: {
    LearningGroupAddStudentsTableItem,
    LearningGroupStudentTableItem,
    CourseRegistrationsTableItem,
    CustomTable
  }
})
export default class LearningGroupAddStudentsTable extends Vue {
  @Prop() courseId!: string;
  students: Array<any> = [];
  checkedAll: boolean = false;
  checkedItems: any[] = [];
  indeterminate: boolean = false;
  pageNumber: number = 1;
  count: number = 0;
  isLoading: boolean = false;

  form: any = {
    offset: 0,
    limit: 30
  };

  @Watch("courseId", { immediate: true })
  checkStudents() {
    if (this.courseId) {
      this.checkedItems = [];
      this.getStudents();
    }
  }

  changePage() {
    this.$nextTick(() => {
      this.checkedItems = [];
      if (this.form && this.form.limit) {
        this.form.offset = this.form.limit * (this.pageNumber - 1);
        this.getStudents();
      }
    });
  }

  toggleAll(checked: boolean) {
    this.checkedItems = checked ? this.students.slice() : [];
  }

  @Watch("checkedItems")
  checkSelected(newValue: any) {
    if (newValue.length === 0) {
      this.indeterminate = false;
      this.checkedAll = false;
    } else if (newValue.length === this.students.length) {
      this.indeterminate = false;
      this.checkedAll = true;
    } else {
      this.indeterminate = true;
      this.checkedAll = false;
    }
    this.$emit("getStudents", this.checkedItems);
  }

  getCheckedRegistration(registration: IRegistration) {
    if (!this.checkedItems.some(el => el.id === registration.id)) {
      this.checkedItems.push(registration);
    } else {
      this.checkedItems = this.checkedItems.filter(
        el => el.id !== registration.id
      );
    }
  }

  checkState(id: string) {
    return this.checkedItems.some(el => el.id === id);
  }

  getStudents() {
    this.isLoading = true;
    learningGroupsApi.Group.listLearningGroupAvailableRegistrations(
      this.courseId,
      this.form.offset,
      this.form.limit
    )
      .then(res => {
        this.students = res.data.items;
        this.count = res.data.count;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
